export const privacyHtml = (logo) => {
    return (`
    <!DOCTYPE html>
<html lang="it">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Votiamo App - Privacy Policy</title>
    <style>
        body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            margin: 0;
            padding: 0;
            background-color: #f9f9f9;
            color: #333;
        }
        header {
            text-align: center;
            padding: 20px 0;
            background-color: #fff;
        }
        header img {
            width: 150px;
            height: auto;
        }
        header h1 {
            margin: 10px 0 0;
            font-size: 24px;
            color: #0073a6;
        }
        main {
            padding: 20px;
            max-width: 90%;
            margin: 20px auto;
        }
        h2 {
            color: #005580;
            margin-top: 20px;
        }
        h3 {
            color: #333;
            margin-top: 15px;
        }
        p {
            margin: 10px 0;
        }
        ul {
            margin: 10px 0 20px;
            padding-left: 20px;
        }
        footer {
            text-align: center;
            padding: 10px 0;
            font-size: 12px;
            color: #777;
        }
        .highlight {
            font-weight: bold;
            color: #0073a6;
        }
    </style>
</head>
<body>
    <header>
        <img src="${logo}" alt="Votiamo App Logo">
        <h1>Votiamo App - Informativa sulla privacy</h1>
    </header>
    <main>
        <h2>Introduzione</h2>
        <p>Desideriamo informarLa che Il Cavedio Società Cooperativa, titolare del marchio Votiamo, con sede legale e amministrativa in Via De Cristoforis 12, 21100 Varese (VA), in qualità di Titolare del trattamento dei dati personali ai sensi del Regolamento UE 2016/679 (RGPD o GDPR o Normativa Applicabile), riconosce l'importanza della protezione dei dati personali e considera la sua tutela uno degli obiettivi principali della propria attività.</p>
        <p>In osservanza della Normativa Applicabile, siamo a fornirLe le dovute informazioni in ordine al trattamento dei dati personali da Lei forniti. Si tratta di un'informativa resa ai sensi della Normativa Applicabile, che il Titolare del trattamento La invita a leggere con attenzione, poiché contiene informazioni importanti sulla tutela dei dati personali e sulle misure di sicurezza adottate per garantirne la riservatezza nel pieno rispetto della Normativa Applicabile.</p>
        <p>Il Cavedio Società Cooperativa La informa che il trattamento dei dati personali sarà improntato ai principi di liceità, correttezza, trasparenza, limitazione delle finalità e della conservazione, minimizzazione dei dati, esattezza, integrità e riservatezza. I dati personali verranno pertanto trattati in accordo alle disposizioni legislative della Normativa Applicabile e agli obblighi di riservatezza ivi previsti.</p>

        <h2>Definizioni</h2>
        <ul>
            <li><span class="highlight">"Dato personale"</span>: qualsiasi informazione riguardante una persona fisica identificata o identificabile ("interessato"); si considera identificabile la persona fisica che può essere identificata, direttamente o indirettamente, con particolare riferimento a un identificativo come il nome, un numero di identificazione, dati relativi all'ubicazione, un identificativo online o a uno o più elementi caratteristici della sua identità fisica, fisiologica, genetica, psichica, economica, culturale o sociale.</li>
            <li><span class="highlight">"Trattamento"</span>: qualsiasi operazione o insieme di operazioni, compiute con o senza l'ausilio di processi automatizzati e applicate a dati personali o insiemi di dati personali, come la raccolta, la registrazione, l'organizzazione, la strutturazione, la conservazione, l'adattamento o la modifica, l'estrazione, la consultazione, l'uso, la comunicazione mediante trasmissione, diffusione o qualsiasi altra forma di messa a disposizione, il raffronto o l'interconnessione, la limitazione, la cancellazione o la distruzione.</li>
            <li><span class="highlight">"Dati relativi alla salute"</span>: i dati personali attinenti alla salute fisica o mentale di una persona fisica, compresa la prestazione di servizi di assistenza sanitaria, che rivelano informazioni relative al suo stato di salute.</li>
        </ul>

        <h2>Luogo di Trattamento dei Dati</h2>
        <p>I trattamenti dei dati hanno luogo presso la predetta sede del Titolare, presso le eventuali sedi operative (dove si svolgono i corsi) e presso soggetti terzi individuati dal Titolare.</p>

        <h2>Tipi di Dati Trattati</h2>
        <p>Il trattamento ha ad oggetto i dati personali e identificativi forniti dall'interessato (a titolo esemplificativo ma non esaustivo):</p>
        <ul>
            <li>Nome e cognome</li>
            <li>Indirizzo</li>
            <li>Partita IVA</li>
            <li>Codice fiscale</li>
            <li>Numero di telefono fisso o mobile</li>
            <li>Indirizzo di posta elettronica</li>
            <li>Coordinate bancarie</li>
            <li>Altri dati pertinenti</li>
        </ul>

        <h2>Finalità, Base Giuridica e Natura Obbligatoria o Facoltativa del Trattamento</h2>
        <p>I dati personali forniti saranno oggetto di trattamento da parte del Titolare per le seguenti finalità:</p>
        <h3>a) Amministrativo-contabili</h3>
        <p>Ai fini dell'applicazione delle disposizioni in materia di protezione dei dati personali, i trattamenti effettuati per finalità amministrativo-contabili sono quelli connessi allo svolgimento delle attività di natura organizzativa, amministrativa, finanziaria e contabile, a prescindere dalla natura dei dati trattati. In particolare, perseguono tali finalità:</p>
        <ul>
            <li>Attività organizzative interne</li>
            <li>Adempimento di obblighi contrattuali e precontrattuali</li>
            <li>Gestione del rapporto in tutte le sue fasi</li>
            <li>Tenuta della contabilità</li>
            <li>Applicazione delle norme in materia fiscale, sindacale, previdenziale-assistenziale, di salute, igiene e sicurezza sul lavoro</li>
        </ul>

        <h3>b) Informative e promozionali</h3>
        <p>L'utilizzo delle coordinate di posta elettronica fornite è consentito ai fini di invio di informative e newsletter. L'interessato, al momento della raccolta e in occasione dell'invio di ogni comunicazione, è informato della possibilità di opporsi in ogni momento al trattamento, in maniera agevole e gratuitamente.</p>
        <p>Per cancellarsi dalla mailing list sarà sufficiente scrivere in qualsiasi momento una e-mail all'indirizzo e-mail aziendale, ovvero per posta all'indirizzo fisico del Titolare sopra indicato (sede) con oggetto "Cancellazione Mailing List".</p>

        <h2>Modalità del Trattamento – Conservazione dei Dati</h2>
        <p>Il trattamento sarà svolto in forma automatizzata e manuale, con modalità e strumenti volti a garantire la massima sicurezza e riservatezza, ad opera di soggetti nominati responsabili ed addetti del trattamento ai sensi della normativa applicabile.</p>
        <p>I dati saranno conservati per un periodo non superiore agli scopi per i quali i dati sono stati raccolti e successivamente trattati, ed in ogni caso in costanza del rapporto contrattuale o commerciale in essere.</p>

        <h2>Ambito di Comunicazione e Diffusione</h2>
        <p>I dati oggetto del trattamento non saranno diffusi, salvo esplicita autorizzazione dell'interessato rilasciata previa idonea informativa.</p>
        <p>I dati potranno invece essere comunicati a società contrattualmente legate al Titolare del trattamento e, ove necessario, anche presso soggetti all'interno e all'esterno dell'Unione Europea, in conformità e nei limiti di cui al GDPR.</p>
        <p>I dati potranno essere comunicati in tal senso a terzi appartenenti alle seguenti categorie:</p>
        <ul>
            <li>Soggetti che forniscono servizi per la gestione del sistema informativo usato dal Titolare del trattamento e delle reti di telecomunicazioni, e che curano la manutenzione della parte tecnologica (sito web, applicazione mobile, posta elettronica e servizio di newsletter)</li>
            <li>Liberi professionisti, studi o società nell'ambito di rapporti di assistenza e consulenza</li>
            <li>La società IL Cavedio SSD a RL, socia del Cavedio Società Cooperativa e con cui condivide il database clienti</li>
            <li>Soggetti che svolgono adempimenti di controllo, revisione e certificazione delle attività poste in essere dal Titolare del trattamento</li>
            <li>Autorità competenti per adempimenti di obblighi di leggi e/o di disposizioni di organi pubblici, su richiesta degli stessi</li>
        </ul>
        <p>I dati identificativi trattati in applicazione delle procedure di sicurezza aziendale non sono oggetto di comunicazione, fatte salve espresse e specifiche richieste eventualmente avanzate dalle competenti Autorità giudiziarie ed investigative.</p>
        <p>Ogni ulteriore comunicazione o diffusione avverrà solo previo esplicito consenso dell'interessato.</p>
        <p>Inoltre, nel corso delle ordinarie attività di trattamento, potranno accedere ai dati personali ed identificativi, e quindi venirne a conoscenza, i soggetti espressamente designati dalla scrivente come responsabili e/o addetti del trattamento, autorizzati secondo i rispettivi profili.</p>

        <h2>Natura del Conferimento e Rifiuto</h2>
        <p>Per quanto concerne i dati che siamo obbligati a conoscere al fine di adempiere agli obblighi discendenti dai contratti in essere, e agli obblighi previsti da leggi, regolamenti, normativa comunitaria, o da disposizioni impartite dalle Autorità a ciò legittimate dalla legge e da organi di vigilanza e controllo, il loro mancato conferimento comporterà l'impossibilità di instaurare o proseguire il rapporto, nei limiti in cui tali dati sono necessari all'esecuzione dello stesso.</p>
        <p>Il conferimento dei dati per consentire al Titolare l'invio di comunicazioni commerciali è facoltativo; l'interessato può opporsi in ogni momento al trattamento esercitando i diritti previsti dalla Normativa Applicabile nelle forme e nei modi indicati nella presente.</p>
        <p>Il Titolare rende noto, inoltre, che l'eventuale non comunicazione, o comunicazione errata, di una delle informazioni obbligatorie, ha come conseguenze emergenti:</p>
        <ul>
            <li>L'impossibilità del Titolare di garantire la congruità del trattamento stesso ai patti contrattuali per cui esso sia eseguito</li>
            <li>La possibile mancata corrispondenza dei risultati del trattamento stesso agli obblighi imposti dalla normativa fiscale, amministrativa e civilistica cui esso è indirizzato</li>
        </ul>

        <h2>Dettagli sull'Utilizzo dei Dati nell'Applicazione Mobile</h2>
        <p>In Votiamo, ci impegniamo a proteggere la tua privacy e a garantire la sicurezza dei tuoi dati personali. Questa sezione spiega come raccogliamo, utilizziamo e salvaguardiamo le tue informazioni all'interno della nostra app.</p>

        <h3>Dati Personali Richiesti</h3>
        <p>Per utilizzare la nostra app, richiediamo alcune informazioni personali:</p>
        <ul>
            <li>Data di nascita</li>
            <li>Genere</li>
            <li>Città di residenza</li>
            <li>Stato di famiglia</li>
            <li>Titolo di studio</li>
        </ul>
        <p>Si prega di notare che non richiediamo alcun documento per verificare la validità di questi dati.</p>

        <h3>Utilizzo dei Dati Personali</h3>
        <p>I dati personali che fornisci sono utilizzati esclusivamente a fini statistici. Questo ci consente, insieme ai creatori di sondaggi, di analizzare meglio i risultati da diverse prospettive, migliorando la rilevanza e l'accuratezza delle informazioni ottenute.</p>

        <h3>Controlli sulla Privacy</h3>
        <ul>
            <li>Impostazioni di Visibilità: Hai la possibilità di nascondere in tutto o in parte le tue informazioni personali agli altri utenti utilizzando le nostre funzionalità di privacy.</li>
            <li>Partecipazione Privata: Puoi scegliere di partecipare ai sondaggi in modo privato. In questa modalità, le tue risposte non possono essere associate al tuo account da altri utenti; solo il creatore del sondaggio può vedere le tue risposte collegate al tuo profilo.</li>
            <li>Partecipazione Anonima: Se il creatore del sondaggio lo permette, puoi partecipare in modo anonimo. Questo garantisce che né altri utenti né il creatore del sondaggio possano associare le tue risposte al tuo account.</li>
        </ul>

        <h3>Restrizioni di Accesso ai Sondaggi</h3>
        <p>I creatori di sondaggi hanno la possibilità di limitare la partecipazione in base alle caratteristiche personali fornite. Ad esempio, possono creare sondaggi esclusivamente per residenti di determinate città o per specifici gruppi demografici. Questo aiuta a indirizzare il pubblico desiderato per risultati più pertinenti.</p>

        <h3>Protezione delle Informazioni di Contatto</h3>
        <p>I tuoi dati di contatto—specificamente il tuo indirizzo email e numero di telefono—sono strettamente confidenziali:</p>
        <ul>
            <li>Non Divulgazione: In nessun caso i tuoi dati di contatto saranno resi visibili ad altri utenti o comunicati ai creatori di sondaggi.</li>
            <li>Sicurezza dei Dati: Utilizziamo misure di sicurezza robuste per proteggere le tue informazioni di contatto da accessi non autorizzati o divulgazioni.</li>
        </ul>

        <h3>Riepilogo</h3>
        <ul>
            <li>Gli utenti che partecipano ai sondaggi in modo non anonimo espongono le proprie informazioni solo al creatore del sondaggio, non agli altri partecipanti.</li>
            <li>Hai il pieno controllo dei tuoi dati e puoi regolare le tue impostazioni sulla privacy in qualsiasi momento.</li>
            <li>In nessun caso i tuoi contatti sono comunicati al creatore del sondaggio o ad altri utenti.</li>
            <li>La nostra priorità è garantire la tua privacy e proteggere le tue informazioni personali durante tutta la tua esperienza con Votiamo.</li>
        </ul>
        <p>Se hai domande o necessiti di ulteriori chiarimenti su come vengono utilizzati i tuoi dati, ti preghiamo di contattare il nostro team di supporto. La tua privacy è la nostra massima priorità, e siamo qui per assisterti con qualsiasi preoccupazione.</p>

        <h2>Diritti dell'Interessato</h2>
        <p>La informiamo infine che in ogni momento potrà esercitare i diritti nei confronti del Titolare del trattamento ai sensi della Normativa Applicabile, quindi ottenere:</p>
        <ul>
            <li>La conferma dell'esistenza o meno dei medesimi dati</li>
            <li>Conoscerne il contenuto e l'origine</li>
            <li>Verificarne l'esattezza</li>
            <li>Chiederne l'integrazione, l'aggiornamento oppure la rettificazione</li>
        </ul>
        <p>Al ricorrere delle condizioni previste dalla Normativa Applicabile, Lei ha il diritto di chiedere:</p>
        <ul>
            <li>La rettifica e la cancellazione</li>
            <li>La limitazione di trattamento</li>
            <li>La portabilità dei dati</li>
            <li>Di opporsi, per motivi legittimi, al loro trattamento</li>
        </ul>

        <p>Le richieste vanno rivolte via e-mail all'indirizzo del Responsabile del Trattamento: info@ilcavedio.coop</p>

        <p><strong>Varese, 1° settembre 2024</strong></p>
        <p><strong>Il Titolare del trattamento</strong><br>Il Cavedio Società Cooperativa</p>
    </main>
    <footer>
        <p>&copy; 2026 Il Cavedio Società Cooperativa. Tutti i diritti riservati.</p>
    </footer>
</body>
</html>
    `)
};